// app/modules/auth/components/ChatBotIcon.jsx
import {useState} from 'react'
import {createPortal} from 'react-dom'
import {Bot, X, Minus, Maximize2, Minimize2} from 'lucide-react'
import ChatbotWidget from './ChatbotWidget'

const IDLE_LIMIT_MS = 50 * 60 * 1000
const LAST_ACTIVE_KEY = 'chatbot_last_active'

const ChatBotIcon = () => {
  const [hasOpened, setHasOpened] = useState(false)
  const [visible, setVisible] = useState(false)
  const [size, setSize] = useState('mini')
  const [sessionKey, setSessionKey] = useState(0)

  const handleActivity = () => {
    window.localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()))
  }

  const handleOpen = () => {
    const lastActive = Number(window.localStorage.getItem(LAST_ACTIVE_KEY) || 0)
    const idleFor = Date.now() - lastActive

    if (hasOpened && lastActive > 0 && idleFor > IDLE_LIMIT_MS) {
      setSessionKey((prev) => prev + 1)
      window.localStorage.removeItem(LAST_ACTIVE_KEY)
    }

    setHasOpened(true)
    setVisible(true)
  }

  const handleMinimize = () => {
    setVisible(false)
  }

  const handleClose = () => {
    setVisible(false)
    setHasOpened(false)
    window.localStorage.removeItem(LAST_ACTIVE_KEY)
  }

  const toggleSize = () => {
    setSize((prev) => (prev === 'full' ? 'mini' : 'full'))
  }

  const panel = hasOpened && (
    <div className='chatbot-widget'>
      <div
        className={[
          'chatbot-panel',
          size === 'mini' ? 'chatbot-panel-mini' : '',
          visible ? '' : 'chatbot-panel-hidden',
        ]
          .join(' ')
          .trim()}
      >
        <div className='chatbot-panel-controls'>
          <button className='chatbot-ctrl-btn' onClick={handleMinimize} title='Minimize'>
            <Minus size={14} />
          </button>
          <button
            className='chatbot-ctrl-btn2'
            onClick={toggleSize}
            title={size === 'full' ? 'Restore' : 'Maximize'}
          >
            {size === 'full' ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
          </button>
          <button
            className='chatbot-ctrl-btn chatbot-ctrl-close'
            onClick={handleClose}
            title='Close'
          >
            <X size={14} />
          </button>
        </div>
        <ChatbotWidget key={sessionKey} onActivity={handleActivity} />
      </div>
    </div>
  )

  return (
    <div className='chatbot-widget'>
      {!visible && (
        <button className='chatbot-icon' onClick={handleOpen}>
          <Bot />
        </button>
      )}
      {typeof document !== 'undefined' && createPortal(panel, document.body)}
    </div>
  )
}

export default ChatBotIcon
